import gql from "graphql-tag";
import { SubTaskInfoFragment } from "./fragments";

export const SubtaskSuscribtions = gql`
  subscription subtasks($clientUID: ID) {
    subtasks(clientUID: $clientUID) {
      ...SubTaskInfo
    }
  }
  ${SubTaskInfoFragment}
`;
